module.exports = __webpack_public_path__ + "img/forte7.f7f269bb.jpeg";